<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <!--列表-->
    <el-table :data="articles" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
      class="custom-tbl" style="width: 100%">
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column type="index" width="50"> </el-table-column>
      <el-table-column prop="Title" label="标题" width="150" sortable>
      </el-table-column>
      <el-table-column prop="Content" label="内容" width="500" sortable>
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.Content" placement="top">
            <div class="text-truncate">{{ scope.row.Content }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" width="200" sortable>
      </el-table-column>
      <el-table-column prop="CreateBy" label="创建人" width="200" sortable>
      </el-table-column>
      <el-table-column prop="ModifyBy" label="修改人" width="200" sortable>
      </el-table-column>
      <el-table-column prop="ModifyTime" label="修改时间" width="280" sortable>
      </el-table-column>
    </el-table>

    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm" :label-position="'right'">
        <el-form-item label="标题" prop="Title">
          <el-input v-model="addForm.Title" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="机构类型">
          <el-form-item prop="HospitalType">
            <el-select v-model="addForm.HospitalType">
              <el-option label="市级医院" :value="1"></el-option>
              <el-option label="县级医院" :value="2"></el-option>
              <el-option label="卫生院" :value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>

        <el-form-item label="内容" prop="Content">
          <el-input type="textarea" v-model="addForm.Content" :autosize="{ minRows: 5, maxRows: 20 }"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" ref="editForm" :rules="editRules">

        <el-form-item label="标题" prop="Title">
          <el-input v-model="editForm.Title" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="机构类型">
          <el-select v-model="editForm.HospitalType" placeholder="请选择机构类型">
            <el-option label="市级医院" :value="1"></el-option>
            <el-option label="县级医院" :value="2"></el-option>
            <el-option label="卫生院" :value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="内容" prop="Content">
          <el-input class="input-content" type="textarea" v-model="editForm.Content" auto-complete="off"
            :autosize="{ minRows: 5, maxRows: 20 }"></el-input>
        </el-form-item>



      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="50" :total="total"
        style="float: right">
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
import {
  getArticleListPage,
  addArticle,
  editArticle,
  DeleteArticle,
} from "../../api/ArticleContent/ArticleContent"
import util from "../../../util/date";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
export default {
  components: { Toolbar },
  data () {
    return {
      filters: {
        name: "",
      },
      articles: [],
      buttonList: [],
      currentRow: null,
      page: 1,
      total: 0,
      listLoading: false,
      sels: [], //列表选中列

      addFormVisible: false,
      addLoading: false,
      addForm: {
        Title: "",
        HospitalType: "",
        Content: "",
      },
      addFormRules: {
        Title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        Content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        HospitalType: [{ required: true, message: "请输入机构类型", trigger: "change" }],
      },

      editFormVisible: false,
      editLoading: false,
      editForm: {
        Title: "",
        HospitalType: "",
        Content: "",
      },
      editRules: {
        Title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        Content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        HospitalType: [{ required: true, message: "请输入机构类型", trigger: "change" }],
      },

    }

  },
  methods: {
    dialogCheck (selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    callFunction (item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    selectCurrentRow (val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
          new Date(row.CreateTime),
          "yyyy-MM-dd hh:mm:ss"
        );
    },
    formatModifyTime: function (row, column) {
      return !row.ModifyTime || row.ModifyTime == ""
        ? ""
        : util.formatDate.format(
          new Date(row.ModifyTime),
          "yyyy-MM-dd hh:mm:ss"
        );
    },
    handleCurrentChange (val) {
      this.page = val;
      this.GetArticleList();
    },
    //获取指南
    GetArticleList () {
      let para = {
        page: this.page,
        key: this.filters.name,
        PageSize: this.pageSize,
      };
      this.listLoading = true;
      getArticleListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.articles = res.data.response.data;
        this.listLoading = false;
      });
    },
    handleAdd () {
      this.addForm = {
        Title: "",
        HospitalType: "",
        Content: "",
      },
        this.addFormVisible = true;

    },
    handleEdit () {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    handleDel () {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          DeleteArticle(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.currentRow = null; // Clear current row selection
              this.GetArticleList(); //
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

          });
        })
        .catch(() => { });

    },
    editSubmit: function () {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            editArticle(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.currentRow = null; // Clear current row selection
                this.editFormVisible = false;
                this.GetArticleList();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);
            addArticle(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              this.addLoading = false;
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                // his.$refs.table.setCurrentRow();
                this.addFormVisible = false;
                this.GetArticleList();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },

  },
  mounted () {
    this.GetArticleList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
  },


}
</script>

<style scoped>
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
</style>